import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navbar } from "./layout/Navbar";
import { Footer } from "./layout/Footer";
import { Home } from "./components/home/home";
import { About } from "./components/about/about";
import { Contact } from "./components/contact/contact";
import { NotFound } from "./components/notfound/notfound";
import { Projects } from "./components/projects/projects";
import { Experience } from "./components/experience/experience";
import { MetaTags } from "./components/MetaTags";

function App () { 
  return (
    <Router>
      <MetaTags />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;